<template>
<section id="about-me">
    <div class="py-6"></div>
    <v-container class="text-center">
        <h2 class="display-2 font-weight-bold mb-3">NEWS</h2>

        <v-responsive class="mx-auto divMargin" width="56">
            <v-divider class="mb-1"></v-divider>
            <v-divider></v-divider>
        </v-responsive>

        <v-row class="left">
            <v-col class="left margin_top" cols="12" lg="6" v-if="!loadingNews">
                <ul dense class="scroll">
                    <template v-for="item in news" class="">
                        <li :key="item.id" avatar class="padding-right left">
                            <h3 class="text gray">{{getFecha(item.date)}}</h3>
                            <p class="mb text gray">{{item.data}}</p>
                        </li>
                    </template>
                </ul>
            </v-col>
            <!-- <v-col class="center" cols="12" lg="6" v-if="!loadingNews">
                <v-row fluid v-for="item in news" :key="item.id">
                    <v-card class="ma-2" elevation="0">
                        <v-card-title class="text">{{getFecha(item.date)}}</v-card-title>
                        <v-row v-if='item.img'>
                            <v-col cols=8>
                                <p class="text gray">{{item.data}}</p>
                            </v-col>
                            <v-col cols=4>
                                <v-img contain max-height="200px" :src="item.img" />
                            </v-col>
                        </v-row>
                        <v-card-text v-else class="text">{{item.data}}</v-card-text>
                    </v-card>
                    <v-divider />
                </v-row>
            </v-col> -->
            <v-col wrap class="center" cols="12" lg="6">
                <Timeline widget-class="mt-3 my-custom-class twitter" id="shrikezhang" sourceType="profile" :options="{ tweetLimit: '3' }" />
            </v-col>
        </v-row>
    </v-container>

    <div class="py-12"></div>
</section>
</template>

<script>
import {
    Timeline
} from "vue-tweet-embed";
import {
    mapState
} from "vuex";
export default {
    name: "News",
    computed: {
        ...mapState(["loadingNews", "news"]),
        filteredNews() {
            return this.news.slice(0, 6);
        }
    },
    methods: {
        getFecha(date) {
            return new Date(date.seconds * 1000).toDateString();
        }
    },
    mounted() {
        if (!this.news.length) this.$store.dispatch("cargarNews");
        //console.log(this.news)
    },
    components: {
        Timeline
    }
};
</script>

<style scoped>
.noPadding {
    padding: 0em !important;
}

.margin {
    margin-top: 2rem;
    margin-bottom: 0;
}

.margin_top{
    margin-top: 15px;
}

.mb{
    margin-bottom: 35px;
}

.center {
    align-self: top;
    align-content: center;
    text-align: center !important;
}

.divMargin {
    margin-bottom: 1rem !important;
    margin-top: 1rem !important;
}

.text {
    text-align: justify;
    margin-right: 20px;
    
    padding-bottom: 10px;
    font-size: 2.4vmin;
    word-break: break-word;
}

.awards {
    font-size: 2rem;
    margin-bottom: 0.5rem !important;
}

.left{
    text-align: justify;
}

.padding-right{
    padding-right: 12px;
}

.scroll {
    overflow-y: scroll;
    max-height: 70vmax;
    margin-top: 12px;
    scrollbar-color: red yellow !important;
}

.vertical {
    vertical-align: top;
}

.margin-right{
    margin-right: 10px;
}

.heightt {
    height: 300px;
}

.gray {
    color: rgba(0, 0, 0, 0.6);
}
</style>
